import React from 'react'
import { OnboardingWizardProvider } from 'apps/fleet-planner/context'
import { OnboardingWizard } from './OnboardingWizard'

export const OnboardingWizardPage = () => {
  return (
    <OnboardingWizardProvider>
      <OnboardingWizard />
    </OnboardingWizardProvider>
  )
}
